export default __webpack_public_path__ + "static/media/Sort-Z-A.a7f68594.svg";